export default "__VITE_ASSET__412aa33c__"